import { AvatarRoot, AvatarImage, AvatarFallback } from '@chakra-ui/react';
import { EventChatAvatar } from './EventChatAvatar';

type Size = 'sm' | 'md' | 'lg';

type Props = {
  kind: 'event' | 'direct' | 'department';
  /** `events.image` storage path for an event, or `profiles.profile_image` URL for a person. */
  stored: string | null | undefined;
  name: string | null | undefined;
  size?: Size;
};

/**
 * Avatar for a chat list row. Event images live in a private bucket and need signing;
 * profile images are already plain URLs, so they render directly.
 *
 * A department chat is identified by its event's image -- it has no image of its own,
 * and the department name is already the row's title.
 */
export function ChatAvatar({ kind, stored, name, size = 'md' }: Props) {
  if (kind === 'event' || kind === 'department') {
    return <EventChatAvatar stored={stored} name={name} size={size} />;
  }

  const hasImage = Boolean(stored?.trim());
  return (
    <AvatarRoot size={size} bg="purple.100" color="purple.600" fontWeight="bold" flexShrink={0}>
      {hasImage ? <AvatarImage src={stored!} alt="" /> : null}
      <AvatarFallback name={name ?? 'V'} />
    </AvatarRoot>
  );
}
